import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            实时快讯
          </h2>
          <p className="text-sm text-foreground-500">24小时滚动更新，娱乐大事不错过</p>
        </div>

        <div className="max-w-[900px] mx-auto relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200"></div>

          <div className="space-y-5">
            {updateItems.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 pl-12">
                <span className="absolute left-[13px] top-2 w-3.5 h-3.5 rounded-full bg-primary-500 border-2 border-background-50"></span>
                <div className="flex-1 bg-background-50 border border-background-200/70 rounded-xl p-4 hover:border-primary-200 transition-all duration-200 cursor-pointer">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold text-white ${item.tagColor}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}